import { render, staticRenderFns } from "./ViewProduct.vue?vue&type=template&id=483cbb5c"
import script from "./ViewProduct.vue?vue&type=script&lang=js"
export * from "./ViewProduct.vue?vue&type=script&lang=js"
import style0 from "./ViewProduct.vue?vue&type=style&index=0&id=483cbb5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports